// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__Cwo3h","vatRate":"styles_vatRate____V74","vatRateLabel":"styles_vatRateLabel__fpmbK","slideInSearchBar":"styles_slideInSearchBar__RvdyQ"};